import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/audit'
const auditEnumUrl = 'v1/auditEnum'
const plural = 'audits'
const single = 'audit'
const exportAuditUrl = 'v1/audit/export'

const audit = new ApiCore({
	index: true,
	findOne: true,
	url: url,
	plural: plural,
	single: single
})

audit.getAuditEnum = (_action) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${auditEnumUrl}`)
		.then(handleResponse)
		.catch(handleError);
}

audit.exportAuditData = (payload, type, params) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${exportAuditUrl}/${type}`, payload, params)
		.then(handleResponse)
		.catch(handleError);
}

export default audit
